import { ContactlessIcon, customUseEffect, ErrorNotifier, IconButton, MuiTooltip, useDispatch, useState } from "@common";

const OAuthConnectButton = ({ id, action }) => {
    const [errorMessage, setErrorMessage] = useState("");
    const dispatch = useDispatch();

    // Clear Time Out When Componet is UnMounted
    customUseEffect(() => {
        if (!errorMessage) return;

        const timer = setTimeout(() => {
            setErrorMessage("");
        }, 2000);

        return () => clearTimeout(timer);
    }, [errorMessage]);

    const handleConnect = (e) => {
        e.stopPropagation();

        dispatch(action({ id }))
            .unwrap()
            .then((res) => {
                const redirectUrl = res?.data?.redirect_url;

                if (redirectUrl) {
                    // Open OAuth page in new tab
                    window.open(redirectUrl, "_blank", "noopener,noreferrer");
                }
            })
            .catch((err) => {
                const error =
                    err?.data?.message || err?.message || "Failed to connect.";
                setErrorMessage(error);
            });
    };

    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <MuiTooltip title="Connect">
                <IconButton style={{ padding: "0rem" }} onClick={handleConnect}>
                    <ContactlessIcon sx={{ color: "green !important" }} />
                </IconButton>
            </MuiTooltip>
            {errorMessage && (
                <ErrorNotifier message={errorMessage} />
            )}
        </div>
    );
};

export default OAuthConnectButton;